"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var Indicator = _styledComponents["default"].div.attrs(function () {
  return {
    className: "d-flex justify-content-center align-items-center",
    id: "best-env-indicator"
  };
}).withConfig({
  displayName: "EnvIndicator__Indicator",
  componentId: "sc-1rm8qq4-0"
})(["height:100%;width:100%;color:#ffffff;background:", ";text-align:center;font-weight:bold;font-size:0.75rem;z-index:1050;"], function (props) {
  return props.theme.environment && props.theme.environment[props.env] && props.theme.environment[props.env].background ? props.theme.environment[props.env].background : "#e50021";
});
Indicator.defaultProps = {
  env: "dev"
};
var EnvIndicator = function EnvIndicator(_ref) {
  var env = _ref.env;
  var getEnv = function getEnv() {
    switch (env) {
      case "local":
      case "dev":
      case "qa":
      case "stg":
        return _react["default"].createElement(Indicator, {
          env: env.toLowerCase()
        }, env.toUpperCase());
      case "prod":
      case "production":
      default:
        return "";
    }
  };
  return getEnv();
};
var _default = EnvIndicator;
exports["default"] = _default;